<template>
  <div
    class="h-full pr-3 grid grid-cols-3 gap-4 grid-rows-1 print:grid-cols-3 print:gap-4 print:grid-rows-1 border-collapse border-transparent pl-3 py-3"
    :class="globalStyles.font"
  >
    <div
      class="py-4 block print:block col-span-1 rounded-lg"
      :class="styles.bg[globalStyles.bg]"
    >
      <div class="w-32 h-32 mx-auto my-auto">
        <img
          class="object-cover w-full border-4 border-gray-200 rounded-full h-32 bg-gray-50"
          :src="bioInfo.image"
          alt="profile_image"
        />
      </div>
      <div
        class="flex flex-col justify-center p-3 text-xs leading-5 space-y-5 font-semibold"
        :class="styles.bg[globalStyles.bg]"
      >
        <div class="flex items-center">
          <svg
            class="h-4 w-4 flex-shrink-0 mr-1.5 text-gray-200"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          <span class="text-white">{{ basics.email }}</span>
        </div>

        <div class="flex items-center">
          <svg
            class="h-4 w-4 flex-shrink-0 mr-1.5 text-gray-200"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
            />
          </svg>
          <span class="text-white">{{ basics.phone }}</span>
        </div>
        <div class="flex items-center">
          <svg
            class="h-4 w-4 flex-shrink-0 mr-1.5 text-gray-200"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
          <span class="text-white">{{ basics.location.address }}</span>
        </div>
        <div class="flex items-center">
          <svg
            class="h-4 w-4 flex-shrink-0 mr-1.5 text-gray-200"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <span class="text-white">{{ basics.birthday }}</span>
        </div>
      </div>
      <div class="pl-3 mt-3">
        <div class="flex items-center">
          <svg
            class="h-6 w-6 flex-shrink-0 mr-1.5 text-white"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
            />
          </svg>
          <h1
            class="my-3 text-base font-semibold leading-6 tracking-wider text-white uppercase"
          >
            {{ $t("templates.skills") }}
          </h1>
        </div>

        <div class="flex flex-wrap -mr-1 print:-mr-2">
          <span
            v-for="(skill, index) in skills"
            :key="index"
            class="block px-3 py-2 my-1 mr-2 text-sm text-gray-100 rounded-lg"
            :class="styles.bgDarkest[globalStyles.bgDarkest]"
            >{{ skill.name }}</span
          >
        </div>
      </div>
      <div class="px-3 mt-3" v-if="control.idioms">
        <div class="flex items-center">
          <svg
            class="h-6 w-6 flex-shrink-0 mr-1.5 text-white"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
            />
          </svg>
          <h1
            class="my-3 text-base font-semibold leading-6 tracking-wider text-white uppercase"
          >
            {{ $t("templates.idioms") }}
          </h1>
        </div>
        <div
          class="flex flex-wrap items-center justify-between text-white"
          v-for="(idiom, index) in idioms"
          :key="index"
        >
          <h3
            class="text-sm font-semibold leading-6 tracking-wide text-gray-200"
          >
            {{ idiom.name }}
          </h3>
          <div class="inline-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              :fill="level <= idiom.level ? 'currentColor' : 'none'"
              class="flex-shrink-0 w-5 h-5 mr-1 text-sangray-400"
              v-for="(level, index) in 5"
              :key="index"
            >
              <circle cx="12" cy="12" r="10" />
            </svg>
          </div>
        </div>
      </div>
      <div class="px-3 mt-3" v-if="control.interests">
        <div class="flex items-center">
          <svg
            class="h-6 w-6 flex-shrink-0 mr-1.5 text-white"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
            />
          </svg>
          <h1
            class="my-3 text-base font-semibold leading-6 tracking-wider text-white uppercase"
          >
            {{ $t("templates.interests") }}
          </h1>
        </div>

        <div class="flex flex-wrap -mr-2">
          <span
            class="block px-3 py-2 my-1 mr-1.5 text-sm text-gray-100 border-2 rounded-lg"
            v-for="(interes, index) in interests"
            :key="index"
            >{{ interes }}</span
          >
        </div>
      </div>
      <!-- {{$t("templates.otherData") }} -->
      <div class="px-3 mt-3" v-if="control.otherData">
        <div class="flex items-center">
          <svg
            class="h-6 w-6 flex-shrink-0 mr-1.5 text-white"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <h1
            class="my-3 text-base font-semibold leading-6 tracking-wider text-white uppercase"
          >
            {{ $t("templates.otherData") }}
          </h1>
        </div>
        <div
          class="flex items-center mt-2 text-sm leading-5 text-white"
          v-for="(other, index) in otherData"
          :key="index"
        >
          <svg
            class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-200"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clip-rule="evenodd"
            />
          </svg>
          {{ other }}
        </div>
      </div>
    </div>
    <div class="py-4 bg-white col-span-2 px-0 print:col-span-2 print:px-0">
      <div class="pb-6">
        <h2
          class="font-semibold tracking-tight text-gray-900 text-4xl leading-10"
        >
          {{ basics.name }}
        </h2>
        <h4
          class="mt-1 text-base font-normal leading-8 tracking-tight sm:text-lg sm:leading-7"
          :class="styles.text[globalStyles.text]"
        >
          {{ basics.label }}
        </h4>
        <p class="text-sm leading-5" v-html="basics.summary"></p>
      </div>
      <div class>
        <div class="flex items-center">
          <svg
            class="h-6 w-6 flex-shrink-0 mr-1.5"
            :class="styles.text[globalStyles.text]"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>

          <h1
            class="my-3 text-base font-semibold leading-6 tracking-wider uppercase"
            :class="styles.text[globalStyles.text]"
          >
            {{ $t("templates.experience") }}
          </h1>
        </div>
        <div class="space-y-5">
          <div v-for="(exp, index) in work" :key="index">
            <h2 class="text-lg font-bold leading-6 tracking-wide text-gray-900">
              {{ exp.position }}
              <span
                class="text-xs italic font-light truncate"
                v-if="exp.startDate || exp.endDate"
                >{{ exp.startDate }} &ndash; {{ exp.endDate }}</span
              >
            </h2>
            <!-- <p class="text-xs italic">12/2014 – Actualidad</p> -->
            <h3 class="text-base italic font-light leading-6">
              {{ exp.name }}
            </h3>
            <h4
              class="text-sm font-light leading-6 tracking-wide"
              :class="styles.text[globalStyles.text]"
            >
              {{ $t("templates.experience_task") }}
            </h4>
            <div class="text-sm" v-html="exp.summary"></div>
          </div>
        </div>
        <div class="flex items-center">
          <svg
            class="h-6 w-6 flex-shrink-0 mr-1.5"
            :class="styles.text[globalStyles.text]"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
            />
          </svg>
          <h1
            class="my-3 text-base font-semibold leading-6 tracking-wider uppercase"
            :class="styles.text[globalStyles.text]"
          >
            {{ $t("templates.education") }}
          </h1>
        </div>
        <div class="space-y-5">
          <div v-for="(edu, index) in education" :key="index">
            <h2 class="text-lg font-bold leading-6 tracking-wide text-gray-900">
              {{ edu.studyType }}
              <span
                class="text-xs italic font-light truncate"
                v-if="edu.startDate || edu.endDate"
                >{{ edu.startDate }} &ndash; {{ edu.endDate }}</span
              >
            </h2>
            <h3
              class="text-base font-light leading-6"
              v-html="edu.institution"
            ></h3>
          </div>
        </div>
        <h1
          class="my-1 text-base font-medium leading-6 tracking-wider uppercase"
          :class="styles.text[globalStyles.text]"
          v-if="courses.length > 0"
        >
          {{ $t("templates.courses") }}
        </h1>
        <div class="space-y-1" v-if="courses.length > 0">
          <div v-for="(edu, index) in courses" :key="index">
            <h2 class="text-lg font-bold leading-5 tracking-wide text-gray-900">
              {{ edu.studyType }}
              <span
                class="text-xs italic font-light truncate"
                v-if="edu.startDate || edu.endDate"
                >{{ edu.startDate }} &ndash; {{ edu.endDate }}</span
              >
            </h2>
            <h3
              class="text-base font-light leading-6"
              v-html="edu.institution"
            ></h3>
          </div>
        </div>
        <div v-show="control.projects">
          <div class="flex items-center">
            <svg
              class="h-6 w-6 flex-shrink-0 mr-1.5"
              :class="styles.text[globalStyles.text]"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
              />
            </svg>
            <h1
              class="my-3 text-base font-semibold leading-6 tracking-wider uppercase"
              :class="styles.text[globalStyles.text]"
            >
              {{ $t("templates.projects") }}
            </h1>
          </div>
          <span class="text-sm" v-html="projects"></span>
        </div>
        <div v-show="control.references">
          <div class="flex items-center">
            <svg
              class="h-6 w-6 flex-shrink-0 mr-1.5"
              :class="styles.text[globalStyles.text]"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
              />
            </svg>
            <h1
              class="my-3 text-base font-semibold leading-6 tracking-wider uppercase"
              :class="styles.text[globalStyles.text]"
            >
              {{ $t("templates.references") }}
            </h1>
          </div>
          <span class="text-sm" v-html="references"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    globalStyles: Object,
  },
  computed: {
    ...mapState([
      "bioInfo",
      "basics",
      "skills",
      "idioms",
      "interests",
      "work",
      "otherData",
      "control",
      "projects",
      "references",
    ]),
    ...mapGetters(["courses", "education"]),
    ...mapState("style", ["styles"]),
  },
};
</script>